export const unsupportedBrowserBanner = {
  id: 'unsupportedBrowserBanner',
  type: 'warning',
  message: 'unsupported-browser-banner-message',
  link: {
    label: 'unsupported-browser-banner-link-label',
    url: '/help?ref_\u003dAAC_banner_unsupported_ie#GJQC774WTS333TCR',
  },
};
